import React from "react";
import { FormControl, Select, InputLabel, MenuItem, Box } from "@material-ui/core";
import { preferredLang, changeLanguage } from "utils/localizer";
import i18n from "../i18n";

// lang selector
const LanguageSelect = () => (
    <Box style={{ padding: "16px" }}>
        <FormControl
            margin="dense"
            fullWidth
            variant="outlined"
        >
            <InputLabel>{i18n.language}</InputLabel>
            <Select
                label={i18n.language}
                value={preferredLang}
                onChange={(e) => changeLanguage(e.target.value as string)}
            >
                {Object.entries(i18n.languages).map(([id, lang]) => (
                    <MenuItem key={id} value={id}>{lang as string}</MenuItem>
                ))}
            </Select>
        </FormControl>
    </Box>
);

export default LanguageSelect;
